import Vue from 'vue'
import axios from "axios";
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";

Vue.use(VueToast,{
  position: "top-right",
  duration: 0
});
// add these before Vue is instantiated
axios.defaults.baseURL = "https://api.tickettoghana.co.za";
//axios.defaults.baseURL = "http://127.0.0.1:8000"
Vue.config.productionTip = false
Vue.prototype.axios = axios;


new Vue({
  vuetify,
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
